import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

export const LeadFormDrawer = styled(Drawer)(() => ({
  '& .MuiDrawer-paperAnchorRight': {
    width: `100%`,
  },
}));
